import { Product } from '@v2/shared/lib/types';
import { cn } from '@v2/shared/lib/utils';

/**
 * Only the cover and the name are needed, so that is all this asks for — which lets a
 * caller that holds something leaner than a whole Product use it too. Every existing
 * caller passes a full Product and satisfies this unchanged.
 */
type Props = {
  product: Pick<Product, 'name' | 'featured_image'>;
  className?: string;
  /**
   * Product cards are the page's subject and load eagerly. A long list of covers
   * further down is not, and twenty eager requests would compete with what is.
   */
  loading?: 'eager' | 'lazy';
};

export default function ProductImage({ product, className, loading = 'eager' }: Props) {
  return (
    <img
      alt={product.featured_image.alt_text || product.name}
      src={product.featured_image.url}
      srcSet={product.featured_image.srcset}
      width={product.featured_image.width || 774}
      height={product.featured_image.height || 1018}
      loading={loading}
      className={cn('border-2 border-slate-200 rounded-lg overflow-hidden', className)}
    />
  );
}
